module.exports = __webpack_public_path__ + "img/status_green.f7b81d6c.svg";